import * as React from "react";
import { forwardRef } from "react";
const SvgCalendar = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.3509 4H19.126C20.1064 4 20.9012 4.89543 20.9012 6V20C20.9012 21.1046 20.1064 22 19.126 22H4.92503C3.94465 22 3.1499 21.1046 3.1499 20V6C3.1499 4.89543 3.94465 4 4.92503 4H6.70015V2H8.47528V4H15.5758V2H17.3509V4ZM4.925 20H19.126V9H4.925V20Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgCalendar);
export default ForwardRef;
